import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { RouteParams } from './cms-detail.types';
import { CmsService } from '../cms.service';
import { CmsDetailAccountProps } from '../../../models/shared.interface';
import { Constants } from '../../../shared/utils/constants';
import { date2String } from '../../../shared/utils/helper';
import { AppService } from '../../../app.service';

@Component({
  selector: 'fx-cms-detail',
  templateUrl: `./cms-detail.component.html`,
  styleUrls: [`./cms-detail.component.scss`],
  host: {
    style: `
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 123;
      width: 100%;
    `
  }
})
export class CmsDetailComponent implements OnInit {
  @ViewChild('addressInfo') addressInfo: ElementRef<HTMLElement>;
  paramsUrl: RouteParams;
  username = '';
  accountList: CmsDetailAccountProps[] = [];
  selectedAddress: any;
  showAddressError = false;
  isEditingAddressDialog = false;
  enableEditProfile = true;
  countries = {};

  constructor(
    private readonly router: Router,
    private readonly location: Location,
    private readonly ar: ActivatedRoute,
    private readonly cmsService: CmsService,
    private readonly appService: AppService
  ) {
    Constants.COUNTRIES.map((c) => {
      this.countries[c.code] = { label: c.name, value: c.code, dialCode: c.dialCode };
    });
  }

  ngOnInit(): void {
    this.paramsUrl = this.ar.snapshot.queryParams as RouteParams;
    this.username = this.paramsUrl.username;
    if (!this.paramsUrl.email || !this.paramsUrl.user_id) {
      this.onBack();
    }
    this.getAccount({ user_id: this.paramsUrl.user_id });
    this.getAddress(this.paramsUrl.user_id);
  }

  getAccount(params: any = {}) {
    this.cmsService.getCmsDetailAccounts(params).subscribe((res) => {
      this.accountList = res.data.accounts;
    });
  }

  getCountryNameByCode(code): string {
    if (this.countries[code]) {
      return this.countries[code].label;
    }
    return '';
  }

  getAddress(params) {
    this.cmsService.getAddressInfoByUser(params).subscribe((res) => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.selectedAddress = {
          ...res.data,
          dob: new Date(res.data.dob),
          fullName: res.data.getFullName(),
          fullNameJP: res.data.fullNameJP(),
          countryName: this.getCountryNameByCode(res.data.country)
        };
      }
    });
  }

  checkInValidAddressInfo() {
    return this.addressInfo['form'].form.invalid || !this.addressInfo['validateDob'];
  }

  refreshAddressInfo() {
    this.addressInfo['validateDob'] = true;
    this.isEditingAddressDialog = false;
    this.showAddressError = false;
  }

  saveEditAddressDialog() {
    this.showAddressError = true;
    if (this.checkInValidAddressInfo()) {
      return;
    }
    const data = {
      user_id: this.selectedAddress.id,
      first_name: this.selectedAddress.firstName.toUpperCase(),
      last_name: this.selectedAddress.lastName.toUpperCase(),
      middle_name: this.selectedAddress.middleName ? this.selectedAddress.middleName.toUpperCase() : null,
      first_name_jp: this.selectedAddress.firstNameJP,
      last_name_jp: this.selectedAddress.lastNameJP,
      city_town: this.selectedAddress.city,
      date_of_birth: date2String(this.selectedAddress.dob, '/'),
      phone_number: this.selectedAddress.phone,
      postal_zipcode: this.selectedAddress.zipCode,
      residential_address: this.selectedAddress.address,
      sex: this.selectedAddress.gender,
      street_number: this.selectedAddress.street,
      country: this.selectedAddress.country,
      building: this.selectedAddress.building || ''
    };
    if (this.selectedAddress.country === 'JP') {
      data.middle_name = null;
      this.selectedAddress.middleName = null;
    }
    this.cmsService.updateCustomerInfo(data).subscribe((res: any) => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.appService.showSuccess('Update Successful');
        this.refreshAddressInfo();
        this.selectedAddress.countryName = this.getCountryNameByCode(this.selectedAddress.country);
        this.getAccount({ user_id: this.paramsUrl.user_id });
        this.enableEditProfile = true;
        void this.router.navigate([], {
          relativeTo: this.ar,
          queryParams: {
            ...this.paramsUrl,
            username: data.first_name + ' ' + data.last_name
          },
          queryParamsHandling: 'merge'
        })
        this.ar.queryParamMap.subscribe(e => {
          this.username = e.get('username')
        })
      } else {
        this.appService.showError('Uppdate Fail');
      }
    });
  }

  onBack() {
    void this.router.navigateByUrl('app/cms');
  }

  onInfoDialogClose() {
    this.enableEditProfile = true;
    this.isEditingAddressDialog = false;
  }
}
